const InventoryIc = () => {
  return (
    <svg
      width="93"
      height="92"
      viewBox="0 0 93 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_26_15)">
        <rect
          x="14.5"
          y="14"
          width="64"
          height="64"
          rx="32"
          fill="url(#paint0_radial_26_15)"
          stroke="#FFDB97"
          stroke-width="4"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_26_15"
          x="0.5"
          y="0"
          width="92"
          height="92"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_26_15"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_26_15"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_26_15"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(46.5 46) rotate(90) scale(34)"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="#DC9716" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default InventoryIc;
